import { render, staticRenderFns } from "./CommunicationTypeDelete.vue?vue&type=template&id=68d24ba9&"
import script from "./CommunicationTypeDelete.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports